import React,{ useState,useEffect } from "react";
import ProductAccountTable from "../ProductAccountTable/ProductAccountTable";
import axios from 'axios';

const BorrowerTable = ({triggerDate,startDate,endDate,borrowerAccount,userId,clientToken}) => {
  
  const [accountList,setAccountList] = useState(null);
  const [ccAuth, setCcAuth] = useState(null);
  var loanArr = [];
  var loanDetailArr = [];
  useEffect(()=> {
    ccAuthToken();
  },[]);

  useEffect(()=>{
    loanData();
    if(ccAuth !== null){
      forCCLoanData();
    }
  },[ccAuth])

  const dataCC = process.env.REACT_APP_ENV === "production" ? { "user": 
                { 
                  "email": "readonly@mintifi.com",
                 "password": "yZ99crWLw4F5fFXt$#"
                }
            } : { "user": 
                { 
                  "email": "test@example.com",
                 "password": "12345678"
                }
            };

  const ccAuthToken = () => {
    var ccAuthUrl = `${process.env.REACT_APP_CASH_COLLATERAL_API_URL}/users/login`;
    var config = {
      url: ccAuthUrl,
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      data: dataCC,
    };

    axios(config)
    .then((res)=>{
      setCcAuth(res.data.auth.token);
      borrowerLoanAccount();
    }).catch((error)=>{
      borrowerLoanAccount();
    });

   };

  const borrowerLoanAccount = () =>{
    var lanList = {};

    for(var index in borrowerAccount) {
      if(borrowerAccount[index].loan_account_economics.length > 0) {

        let loan_account_economics = borrowerAccount[index].loan_account_economics;
        
        for(var index1 in loan_account_economics) {  
          let loan_index = loan_account_economics[index1];
          loan_index.product_name = borrowerAccount[index].product;
          loan_index.roi = borrowerAccount[index].interest_rate ? Number(borrowerAccount[index].interest_rate) : null;          
          loan_index.anchor_name = borrowerAccount[index].anchor_name;
          loan_index.vpin_lf_flag = "";

          if(borrowerAccount[index].lf_loan_application_number !== null && borrowerAccount[index].lf_loan_application_number.length > 0 && borrowerAccount[index].lf_loan_application_number.indexOf(loan_index.loan_account_number) !== -1){
            loan_index.vpin_lf_flag = "lf";
          }

          if(borrowerAccount[index].veefin_od_account_number !== null && borrowerAccount[index].veefin_od_account_number === loan_index.loan_account_number){
            loan_index.vpin_lf_flag = "vp";
          }
          loan_index.eerr = loan_index.loan_account_number;
          loan_index.ba_acc = borrowerAccount[index];
          loan_index.cc_data = loanDetailArr[borrowerAccount[index].id];
          lanList[loan_index.loan_account_number] = loan_index;
   
        }
      }
    }
    setAccountList(lanList);
  }  
  const loanData = ()=>{
    for(var id in borrowerAccount){
      loanArr.push(borrowerAccount[id].id);
    }
  }

  const forCCLoanData = () => {
    // var loanArr = [1,2,3]
    for (var id in loanArr){
      axios.get(`${process.env.REACT_APP_CASH_COLLATERAL_API_URL}/api/v1/loans/${loanArr[id]}`,
        {
            headers: {
              'Authorization': ccAuth
            },
        })
        .then((res)=>{
          loanDetailArr[res.data.loan.id] = res.data;
            borrowerLoanAccount();
        })
        .catch((error)=>{
          borrowerLoanAccount();
        });
    }
  }

  return (
      <>
      {accountList && Object.keys(accountList).map((i)=>
          <div key={"acc"+i}>
            <ProductAccountTable triggerDate={triggerDate} startDate={startDate} endDate={endDate} className="mb-4" borrowerAccount={borrowerAccount} accountList={accountList[i]} userId={userId} clientToken={clientToken} loanDetailArr={loanDetailArr}/>
          </div>
      )}
      </>
    );
  
}
export default BorrowerTable;
